import { Badge } from "@/components/ui/badge";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="mb-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
      <div className="animate-fade-in">
        <h1 className="font-heading text-3xl font-black tracking-tighter sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export function Label2({ children }) {
  return <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-muted-foreground">{children}</span>;
}

const TONES = {
  green: "bg-success/15 text-success border-success/30",
  amber: "bg-warning/15 text-[hsl(38_92%_38%)] dark:text-warning border-warning/30",
  red: "bg-danger/15 text-danger border-danger/30",
  blue: "bg-primary/10 text-primary border-primary/30",
  gray: "bg-muted text-muted-foreground border-border",
};

export function StatusBadge({ tone = "gray", children, testid }) {
  return (
    <Badge data-testid={testid} variant="outline"
      className={`rounded-md border font-semibold ${TONES[tone] || TONES.gray}`}>
      {children}
    </Badge>
  );
}

export const CRIT_TONE = { niedrig: "green", mittel: "blue", hoch: "amber", kritisch: "red" };
export const OP_TONE = { in_betrieb: "green", eingeschraenkt: "amber", ausgefallen: "red", wartung: "blue" };
export const OP_LABEL = { in_betrieb: "In Betrieb", eingeschraenkt: "Eingeschränkt", ausgefallen: "Ausgefallen", wartung: "In Wartung" };
export const MAINT_TONE = { offen: "gray", geplant: "blue", in_arbeit: "amber", abgeschlossen: "green" };
export const RESULT_TONE = { erfolgreich: "green", mit_maengeln: "amber", abgebrochen: "red", bestanden: "green", durchgefallen: "red" };
